export default {
  title: 'Informazioni di contatto',
  form: {
    customer_first_name: {
      placeholder: 'Nome',
    },
    customer_last_name: {
      placeholder: 'Cognome',
    },
    customer_email: {
      placeholder: 'Indirizzo email',
    },
    customer_phone_number: {
      placeholder: 'Numero di telefono',
    },
  },
  validation: {
    customer_first_name: {
      required: 'Inserisci il tuo nome',
    },
    customer_last_name: {
      required: 'Inserisci il tuo cognome',
    },
    customer_email: {
      required: 'Inserisci la tua email',
    },
    customer_phone_number: {
      required: 'Inserisci il tuo numero di telefono',
    },
  },
};
